import { render, staticRenderFns } from "./Checkbox.html?vue&type=template&id=58576ed0&scoped=true&lang=html&"
import script from "./index.vue?vue&type=script&lang=ts&"
export * from "./index.vue?vue&type=script&lang=ts&"
import style0 from "./Checkbox.scss?vue&type=style&index=0&id=58576ed0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58576ed0",
  null
  
)

export default component.exports